{
  "homepage": {
    "ee": "/",
    "ru": "/",
    "en": "/"
  },
  "account": {
    "ee": "/kliendikonto/",
    "ru": "/naznachenie/",
    "en": "/account/"
  },
  "contacts": {
    "ee": "/kompanii/kontakt/",
    "ru": "/kompanija/kontakty/",
    "en": "/company/contact/"
  },
  "about": {
    "ee": "/kompanii/nostrahome/",
    "ru": "/kompanija/o-nas/",
    "en": "/company/nostra/"
  },
  "b2b": {
    "ee": "/kompanii/aerikliendile/",
    "ru": "/kompanija/biznesu/",
    "en": "/company/for-business/"
  },
  "product-payment": {
    "ee": "/tellimisinfo/makseviisid/",
    "ru": "/informacija-pokupatelju/metody-oplaty/",
    "en": "/information/payment-methods/"
  },
  "product-delivery": {
    "ee": "/tellimisinfo/kauba-tarne/",
    "ru": "/informacija-pokupatelju/dostavka-tovara/",
    "en": "/information/delivery/"
  },
  "returns": {
    "ee": "/tellimisinfo/kauba-tagastamine/",
    "ru": "/informacija-pokupatelju/vozvrat-tovara/",
    "en": "/information/returns/"
  },
  "rules": {
    "ee": "/tellimisinfo/tingimused/",
    "ru": "/informacija-pokupatelju/pravila/",
    "en": "/information/terms-and-conditions/"
  },
  "loyalty": {
    "ee": "/tellimisinfo/lojaalsusprogramm/",
    "ru": "/informacija-pokupatelju/programma-lojalnosti/",
    "en": "/information/loyalty-program/"
  },
  "oeko-tex": {
    "ee": "/kompanii/oeko-tex-sertifikaat/",
    "ru": "/kompanija/oeko-tex-standard-100-sertifikat/",
    "en": "/company/oeko-tex-standard-100-certificate/"
  },
  "privacy": {
    "ee": "/tellimisinfo/privaatsuspoliitika/",
    "ru": "/informacija-pokupatelju/konfidencialnost/",
    "en": "/information/privacy/"
  },
  "guestbook": {
    "ee": "/kompanii/kuelalisteraamat/",
    "ru": "/kompanija/gostevaja-kniga/",
    "en": "/company/guest-book/"
  },
  "friends": {
    "ee": "/kompanii/sobrad/"
  },
  "info-exclusive-bedding": {
    "ee": "/informacija-exclusive-voodipesu/"
  },
  "info-mako-satin-bedding": {
    "ee": "/informacija-mako-satiinist-voodipesu/"
  },
  "info-satin-bedding": {
    "ee": "/informacija-satiinist-voodipesu/"
  },
  "info-linen-bedding": {
    "ee": "/informacija-louendist-voodipesu/"
  },
  "info-flannel-bedding": {
    "ee": "/informacija-flanellist-voodipesu/"
  },
  "info-crinkled-bedding": {
    "ee": "/informacija-kortsukangast-voodipesu/"
  },
  "info-mixed-fiber-bedding": {
    "ee": "/informacija-segakiust-voodipesu/"
  },
  "info-bamboo-towels": {
    "ee": "/informacija-bambusest-koeoegiraetikud/"
  },
  "info-towels-550": {
    "ee": "/informacija-kaeteraetikud-550g/"
  },
  "info-towels-380": {
    "ee": "/informacija-kaeteraetikud-380g/"
  },
  "info-cashmere-blankets": {
    "ee": "/informacija-kasmiirist-pleedid/"
  },
  "info-merino-wool-blankets": {
    "ee": "/informacija-meriinovillast-pleedid/"
  },
  "info-wool-blankets": {
    "ee": "/informacija-villased-pleedid/"
  },
  "info-satin-sheets": {
    "ee": "/informacija-satiinist-voodilinad/"
  },
  "info-jersey-sheets": {
    "ee": "/informacija-trikotaazist-voodilinad/"
  },
  "info-terry-sheets": {
    "ee": "/informacija-froteelinad/"
  },
  "info-linen-sheets": {
    "ee": "/informacija-louendriidest-voodilinad/"
  },
  "secret-discount-code": {
    "ee": "/salajane-sooduskood-ee/"
  }
}
